import { useCallback, useLayoutEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
// css
import styles from "./AppoitnmentDetail.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";
import { APPOINTMENT_FORMS_VIEW, APPOINTMENT_LIST } from "config/paths";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useAssignAppointmentChatterMutation, useAssignAppointmentTherpaistMutation, useCreateAppointmentInvoiceMutation, useGetAppointmentAssessmentListQuery, useGetAppointmentAssignedChattertListQuery, useGetAppointmentDetailsQuery, useGetAppointmentTherpaistListQuery, useLazyGetAppointmentTherapistsQuery, useResendConsentFormsMutation, useSendAppointmentInvoiceMutation, useSendAppointmentRecieptMutation, useSendApptMailTherapistMutation, useSendSingleConsentFormMutation, useUnAssignAllAppointmentTherapistMutation, useUnAssignAppointmentChatterMutation, useUnAssignAppointmentTherapistMutation, useUpdateAppointmentConsentFormStatusMutation, useUpdateAppointmentMutation, useUpdateAppointmentPriceMutation } from "store/services/appointment";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { DeleteIcon, ViewDocumentIcon } from "Assets/icons";
import { CommonToolTip } from "components/Common/Common";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { convert12HourTime, convertToMomentDate, dateTimeFormat, getGuardianOptionLabel, successMessageToast } from "helpers/common";
import { debounce } from "lodash";
import IconButton from "components/shared/Buttons/IconButton";
import { useFileViewer } from "hooks/useFileViewer";
import { useGetChatterProgramListQuery } from "store/services/chatter/program";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { CLIENT_TYPE_OPTIONS } from "config/constants";
import AssignTherapistAndChatterModal from "components/Modals/Appointments/AssignTherapistAndChatter";
import AppointmentProgressTracker from "components/shared/AppointmentProgressTracker";
import { getApptTrackerStepStatus } from "utils/common";
import confirmDialog from "utils/confirmationDialog";
import AppointmentTherapistFormPop from "components/Modals/AppointmentTherapistForm";

const AppointmentDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [assessmentOptions, setAssessmentOptions] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [modalType, setModalType] = useState(null)
    const [currentEntry, setCurrentEntry] = useState(null)
    const [currentId, setCurrentId] = useState(null)
    const [appointmentPrice, setAppointmentPrice] = useState(0)
    const [therapistOptions, setTherapistOptions] = useState([])
    const [currentAssignedTherapist, setCurrentAssignedTherapist] = useState(null)
    const { handleViewPdf, getFileLoading } = useFileViewer();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const filter = useSelector(state => state?.filter?.chatterProgramProfilesFilter);
    const [currentChatter, setCurrentChatter] = useState(null)
    const [assignModal, setAssignModal] = useState(false)
    const [therapistFormPop, setTherapistFormPop] = useState(false)
    // const [currentEntry, setCurrentEntry] = useState(null)

    const { data: assessmentProgramList, isFetching: assessmentProgramListFetching } = useGetAppointmentAssessmentListQuery();
    const [updateConsentFormStatus, { isLoading: consenFormStatusLoading }] = useUpdateAppointmentConsentFormStatusMutation()
    const [updateAppointment, { isLoading: updateAppointmentLoading }] = useUpdateAppointmentMutation()
    const [updateApptPrice, { isLoading: updateApptPriceLoading }] = useUpdateAppointmentPriceMutation()
    const [sendSingleConsentForm, { isLoading: sendSingleConsentLoading }] = useSendSingleConsentFormMutation()
    const [getTherapists, { isFetching: therapistsLoading }] = useLazyGetAppointmentTherapistsQuery()
    const [assignTherapist, { isLoading: assignTherapistLoading }] = useAssignAppointmentTherpaistMutation()
    const { data: assignedTherapistList, isFetching: assignedTherapistListLoading } = useGetAppointmentTherpaistListQuery({ id })
    const [unAssignTherapist, { isLoading: unAssignTherapistLoading }] = useUnAssignAppointmentTherapistMutation()
    const [unAssignAllTherapists, { isLoading: unAssignAllTherapistsLoading }] = useUnAssignAllAppointmentTherapistMutation()
    const { data: chatterData, isError: chatterError, isFetching } = useGetChatterProgramListQuery({ page: currentPage, limit: pageSize, ...filter });
    const totalRecords = chatterData?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);
    const [assignChatter, { isLoading: assignChatterLoading }] = useAssignAppointmentChatterMutation()
    const [unAssignChatter, { isLoading: unAssignChatterLoading }] = useUnAssignAppointmentChatterMutation()
    const { data: assignedChatterList, isFetching: assignChatterListLoading } = useGetAppointmentAssignedChattertListQuery({ id })
    const [createInvoice, { isLoading: createInvoiceLoading }] = useCreateAppointmentInvoiceMutation()
    const [sendInvoice, { isLoading: sendInvoiceLoading }] = useSendAppointmentInvoiceMutation()
    const [sendReciept, { isLoading: sendRecieptLoading }] = useSendAppointmentRecieptMutation()
    const [resendConsentForms, { isLoading: resendConsentLoading }] = useResendConsentFormsMutation();
    const [sendMailTherapist, { isLoading: sendMailTherapistLoading }] = useSendApptMailTherapistMutation();


    // get appointment details
    const { data: appointment, isLoading, isError, isFetching: appointmentDetailsLoading } = useGetAppointmentDetailsQuery({ id })
    const consentFormTracking = appointment?.trackers;

    const handleCreateInvoice = async () => {
        try {
            const data = await createInvoice({ id }).unwrap()
            successMessageToast(data?.message)
        } catch (error) {
            console.log("Error sending invoice", error)
        }
    }
    const handleSendInvoice = async () => {
        try {
            const data = await sendInvoice({ id }).unwrap()
            successMessageToast(data?.message)
        } catch (error) {
            console.log("Error sending invoice", error)
        }
    }

    const handleSendReciept = async () => {
        try {
            const data = await sendReciept({ id }).unwrap()
            successMessageToast(data?.message)
        } catch (error) {
            console.log("Error sending invoice", error)
        }
    }

    const handleSendTherapistMail = async (therapistId) => {
        try {
            let isConfirm = await confirmDialog();
            if (!isConfirm) {
                return;
            }

            const data = await sendMailTherapist({ appointmentId: id, therapistId }).unwrap()
            successMessageToast(data?.message)
        } catch (error) {
            console.log("Error sending invoice", error)
        }
    }

    const column = [
        {
            head: "Consent Form Name",
            accessor: "title",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.title}</h6>
            ),
        },


        {
            head: "Status",
            accessor: "status",
            //   sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <p
                    style={{ width: 80 }}
                    className={`${item?.formAssigned?.[0]?.status == "submitted"
                        ? "greenStatus" : item?.formAssigned?.[0]?.status == "pending" ? "yellowStatus"
                            : "redStatus"
                        } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                >
                    {item?.formAssigned?.[0]?.status}
                </p>
            ),
        },

        {
            head: "Verification Status",
            accessor: "verify",
            //   sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <p
                    style={{ width: 80 }}
                    className={`${item?.formAssigned?.[0]?.verify == "verified"
                        ? "greenStatus"
                        : "redStatus"
                        } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                >
                    {item?.formAssigned?.[0]?.verify}
                </p>
            ),
        },

        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">
                    <div style={{ backgroundColor: "#ebffeb", padding: "6px", borderRadius: "100px" }}>

                        <Button
                            onClick={() => navigate(generatePath(APPOINTMENT_FORMS_VIEW, { id: item?.formAssigned?.[0]?.id }))}
                            className="btn  d-flex align-items-center justify-content-center commonBtn fw-sbold"

                        >
                            Preview
                        </Button>

                    </div>
                    <Button
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                        type="button"
                        disabled={item?.formAssigned?.[0]?.status == "pending" || item?.formAssigned?.[0]?.verify == "verified"}
                        onClick={() => {
                            setShowModal(true)
                            setCurrentEntry(item)
                            setModalType("verifyConsentForm")
                        }}
                    >
                        Verify
                    </Button>
                    <Button
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                        variant="transparent"
                        type="button"
                        disabled={item?.formAssigned?.[0]?.status == "verified" || item?.formAssigned?.[0]?.verify == "unverified"}
                        onClick={() => sendMail(item?.formAssigned[0]?.id)}
                    >
                        Send Mail
                    </Button>
                    {/* <CommonToolTip
                    text={item?.status == "active" ? "Archive" : "Unarchive"}
                    component={<Button
                    onClick={() => {
                        setModalType(item?.status == "active" ? "archive" : "active");
                        setCurrentEntry(item);
                        setShowModal(true);
                    }} className="p-0"
                    variant="transparent"
                    type="button"
                    >
                    {item?.status == "active" ? <ArchiveIcon /> : <UnArchiveIcon />}
                    </Button>}
                />
                <CommonToolTip
                    text={"Delete"}
                    component={<Button
                    className="p-0"
                    variant="transparent"
                    type="button"
                    onClick={() => {

                        setCurrentEntry(item);
                        setModalType("delete");
                        setShowModal(true);
                    }}
                    >
                    <DeleteIcon />
                    </Button>}
                /> */}
                </div>
            ),
        },
    ]



    const assignedChattersColumn = [
        {
            head: "Program Name",
            accessor: "name",
            isComponent: true,
            sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-sbold">{item?.assignedAppointmnetPrograms?.name || "--"}</h6>
            )
        },
        {
            head: "Start Date",
            accessor: "start_date",
            sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <>{convertToMomentDate(item?.assignedAppointmnetPrograms?.start_date)}</>
            )
        },
        {
            head: "End Date",
            accessor: "end_date",
            sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <>{convertToMomentDate(item?.assignedAppointmnetPrograms?.end_date)}</>
            )
        },
        {
            head: "Day",
            accessor: "day",
            sorter: true,
            component: (item, ind) => (
                <div className="text-capitalize">{item?.assignedAppointmnetPrograms?.day || "--"}</div>
            )
        },
        {
            head: "Time",
            accessor: "time",
            sorter: true,
            component: (item, ind) => (
                <div>{item?.assignedAppointmnetPrograms?.time ? moment(item?.assignedAppointmnetPrograms?.time, "HH:mm:ss").format("hh:mm A") : "--"}</div>
            )
        },
        // {
        //     head: "Funding Source",
        //     accessor: "FundingSource",
        //     isComponent: true,
        //     component: (item, ind) => (
        //         <h6 className="m-0 fw-sbold">{item?.program_funding_source?.name || "--"}</h6>
        //     )
        // },
        {
            head: "Location",
            accessor: "location",
            sorter: true,
            component: (item, ind) => (
                <div className="text-capitalize">{item?.assignedAppointmnetPrograms?.location || "--"}</div>
            )
        },
        {
            head: "Location Type",
            accessor: "location_type",
            sorter: true,
            component: (item, ind) => (
                <div className="text-capitalize">{item?.assignedAppointmnetPrograms?.location_type || "--"}</div>
            )
        },
        {
            head: "Status",
            accessor: "status",
            sorter: true,
            isComponent: true,
            component: (item, ind) => (
                <p
                    style={{ width: 80 }}
                    className={`${item?.assignedAppointmnetPrograms?.status == "active"
                        ? "greenStatus"
                        : "redStatus"
                        } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                >
                    {item?.assignedAppointmnetPrograms.status}
                </p>
            ),
        },
        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">

                    {/* <CommonToolTip
                text={"Archive"}
                component={<Button
                  className="p-0"
                  variant="transparent"
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();

                    if (!isFetching) {

                    //   setModalType(item?.status == "active" ? "archive" : "active");
                    //   setCurrentEntry(item);
                    //   setShowModal(true);
                    }
                  }}
                >
                  {item?.status == "active" ? <ArchiveIcon /> : <UnArchiveIcon />}
                </Button>}
              />  */}
                    {/* <CommonToolTip
                        text={"Edit"}
                        component={<Button
                            className="p-0"
                            variant="transparent"
                            type="button"
                            onClick={(e) => {

                                e.stopPropagation()
                                setModalType('assignChatter')
                                setCurrentChatter(item)
                                setShowModal(true)
                            }}
                        >
                            <CheckIcon />
                        </Button>}
                    /> */}
                    <CommonToolTip
                        text={"Delete"}
                        component={<Button
                            className="p-0"
                            variant="transparent"
                            type="button"
                            onClick={(e) => {

                                e.stopPropagation()
                                setModalType("unassignChatter");
                                setCurrentChatter(item);
                                setShowModal(true);
                            }}
                        >
                            <DeleteIcon />
                        </Button>}
                    />
                </div>
            ),
        },
    ];

    const therapistColumn = [
        {
            head: "Last Name",
            accessor: "lastname",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.assignedTherapist?.lastname}</h6>
            ),
        },

        {
            head: "First Name",
            accessor: "firstname",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.assignedTherapist?.firstname}</h6>
            ),
        },

        {
            head: "Email",
            accessor: "email",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.assignedTherapist?.email}</h6>
            ),
        },

        {
            head: "Appointment Date",
            accessor: "appointment_dates",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{typeof (item?.appointment_dates) == "string" ? item?.appointment_dates : "--"}</h6>
            ),
        },

        {
            head: "Time Slot",
            accessor: "appointment_dates",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{(item?.appointment_slots?.start_time && item?.appointment_slots?.end_time) ? `${convert12HourTime(item?.appointment_slots?.start_time)} - ${convert12HourTime(item?.appointment_slots?.end_time)}` : "--"}</h6>
            ),
        },
        {
            head: "Form Status",
            accessor: "qaform_status",
            isComponent: true,
            component: (item, ind) => (
                <p
                    className={`${['accepted', 'confirmed', 'completed', 'submitted'].includes(item?.qaform_status)
                        ? "greenStatus"
                        : ['pending'].includes(item?.qaform_status) ?
                            "yellowStatus border" : "redStatus"
                        } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill py-1`}
                >
                    {item?.qaform_status}
                </p>
            ),
        },

        {
            head: "Form",
            accessor: "form",
            isComponent: true,
            component: (item, ind) => (
                <div className="cursor-pointer" onClick={() => { setCurrentId(item); setTherapistFormPop(true) }}>
                    {['accepted', 'confirmed', 'completed', 'submitted'].includes(item?.qaform_status) ? <ViewDocumentIcon /> : ""}
                </div>
            ),
        },

        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">
                    {/* <div style={{ backgroundColor: "#ebffeb", padding: "6px", borderRadius: "100px" }}>
                        <CommonToolTip
                            text={"View"}
                            component={
                                <ViewDocumentIcon
                                    style={{ width: "15px", height: "15px" }}
                                    onClick={() => navigate(`/appointment/formview/${item?.formAssigned?.[0]?.id}`)}
                                    className="cursor-pointer"

                                />}
                        />
                    </div> */}
                    {/* <CommonToolTip
                        text={"Verify"}
                        component={<Button
                            className="p-0"
                            variant="transparent"
                            type="button"
                            disabled={item?.formAssigned?.[0]?.status == "pending" || item?.formAssigned?.[0]?.verify == "verified"}
                            onClick={() => {
                                setShowModal(true)
                                setCurrentEntry(item)
                                setModalType("verifyConsentForm")
                            }}
                        >
                            <VerifyIcon />
                        </Button>}
                    /> */}
                    <CommonToolTip
                        text={"Send Mail"}
                        component={<Button
                            className="btn text-white  d-flex align-items-center justify-content-center commonBtn fw-sbold"
                            variant="transparent"
                            type="button"
                            onClick={() => handleSendTherapistMail(item?.therapist_id)}
                        >
                            Send Mail
                        </Button>}
                    />

                    <CommonToolTip
                        text={"Delete"}
                        component={<Button
                            className="p-0"
                            disabled={item?.appointment_slots != null}
                            variant="transparent"
                            type="button"
                            onClick={() => {
                                setCurrentAssignedTherapist(item);
                                setModalType("unassign");
                                setShowModal(true);
                            }}
                        >
                            <DeleteIcon />
                        </Button>}
                    />
                </div>
            ),
        },
    ]

    const consentFormsTracking = [
        {
            head: "Form Name",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.form_name}</h6>
            ),
        },
        {
            head: "Sent At",
            isComponent: true,
            // sorter: true,
            component: (item) => (
                <h6 className="m-0 fw-bold themeBlue">{dateTimeFormat(item?.resend_time || item?.send_time)}</h6>
            ),
        },
        {
            head: "Viewed At",
            isComponent: true,
            // sorter: true,
            component: (item) => (
                <h6 className="m-0 fw-bold themeBlue">{dateTimeFormat(item?.view_time)}</h6>
            ),
        },
        {
            head: "Submitted At",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{dateTimeFormat(item?.submitted_time)}</h6>
            ),
        },
    ]


    // const handlePageChange = (page) => {
    //     window.scrollTo(0, 0);
    //     setCurrentPage(page);
    // };

    // const handleFilterChange = (key) => (value) => {
    //     dispatch(chatterProgramProfilesFilter({ ...filter, [key]: value }))
    //     setCurrentPage(1);
    // };

    // const resetFilter = () => {
    //     dispatch(chatterProgramProfilesFilter({ search: "", status: "active", sort: { column: "name", direction: "asc" } }));
    //     setCurrentPage(1)
    // };

    const updateConsentForm = async () => {
        try {
            const data = await updateConsentFormStatus({ id: currentEntry?.formAssigned?.[0]?.id, status: "verified", apptId: id }).unwrap()
            successMessageToast(data?.message)
            setShowModal(false)
        } catch (error) {
            console.log('Error updating consent form status', error)
            setShowModal(false)
        }
    }

    const updatePrice = async () => {
        const body = {
            price: appointmentPrice
        }
        try {
            const result = await updateApptPrice({ id, body }).unwrap()
            successMessageToast(result.message);
        } catch (error) {
            console.log("error updating price")
        }
    }


    const sendMail = async (consentFormAssignedId) => {
        try {
            let isConfirm = await confirmDialog();
            if (!isConfirm) {
                return;
            }

            const data = await sendSingleConsentForm({ id: appointment?.record?.id, consentFormAssignedId }).unwrap()
            successMessageToast(data?.message)
        } catch (error) {
            console.log('Error sending appointment mail', error)
            setShowModal(false)
        }
    }

    const getTherapistLookup = async (search, type) => {
        try {

            let result = null;
            const body = {
                search,
                limit: 20
            }

            result = await getTherapists({ body }).unwrap();


            if (!result?.records?.length) {
                return;
            }

            const therapistList = result?.records?.map((item) => ({ value: item.id, label: getGuardianOptionLabel(item), ...item }));
            console.log("THERAPIST LABEL ", therapistList)
            setTherapistOptions(therapistList)

        } catch (err) {
            console.error("error fetching therapists", err)
        };
    };

    const handleSearch = useCallback(debounce((search = "", type) => {
        if (search) getTherapistLookup(search, type);
        else {
            setTherapistOptions([]);
        }
    }, 500), []);

    const handleUnAssignTherapist = async () => {
        setShowModal(false)
        try {
            await unAssignTherapist({ id: currentAssignedTherapist?.id }).unwrap()
        } catch (error) {
            console.log("error unassigning therpaist", error)
        }
    }

    const handleUnAssignAllTherapists = async () => {
        setShowModal(false)
        try {
            await unAssignAllTherapists({ id }).unwrap()
        } catch (error) {
            console.log("error unassigning all therpaists", error)
        }
    }

    const handleAssignChatter = async () => {
        setShowModal(false)
        const body = {
            appointment_id: appointment?.record?.id,
            program_id: currentChatter?.id,
            client_id: appointment?.record?.client_id
        }
        try {
            const result = await assignChatter({ body }).unwrap()
            successMessageToast(result.message)
            console.log('result', result)
        } catch (error) {
            console.log("error unassigning therpaist", error)
        }
    }

    const handleUnAssignChatter = async () => {
        setShowModal(false)
        const body = {
            appointment_id: appointment?.record?.id,
            program_id: currentChatter?.program_id,
            client_id: appointment?.record?.client_id
        }
        try {
            const result = await unAssignChatter({ body }).unwrap()
            successMessageToast(result.message)
        } catch (error) {
            console.log("error unassigning all therpaists", error)
        }
    }

    const handleResendConsentForms = async () => {
        try {
            let isConfirm = await confirmDialog();
            if (!isConfirm) {
                return;
            }

            const result = await resendConsentForms(id).unwrap()
            successMessageToast(result.message)
        } catch (error) {
            console.error("Error resending consent forms", error)
        }
    }

    useLayoutEffect(() => {
        if (assessmentProgramList?.length > 0 && appointment) {
            const data = assessmentProgramList?.filter((item) => appointment?.record?.assessment_services?.includes(item?.id))?.map((item) => ({ label: item?.program_name, value: item?.id }))
            setAssessmentOptions(data)
        }
        if (appointment) {
            setAppointmentPrice(appointment?.record?.price)
        }
    }, [assessmentProgramList, appointment]);

    return (
        <>
            <AssignTherapistAndChatterModal
                id={id}
                appointment={appointment}
                show={assignModal}
                setShow={setAssignModal}
                assessmentOptions={assessmentOptions}
                type={appointment?.record?.appointmentClient?.client_detail?.client_type != "chatter"}
            />
            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                confirmHandler={modalType == "verifyConsentForm" ? updateConsentForm : modalType == "unassign" ? handleUnAssignTherapist : modalType == "unassignAll" ? handleUnAssignAllTherapists : modalType == "assignChatter" ? handleAssignChatter : modalType == "unassignChatter" ? handleUnAssignChatter : sendMail}
                type={modalType}
            />
            <AppointmentTherapistFormPop
                show={therapistFormPop}
                setShow={setTherapistFormPop}
                currentEntry={currentId}
            // currentTherapist={currentTherapist}
            />
            <section
                className={`${styles.ClientDetail} position-relative ClientDetail`}
            >
                <Container fluid={true}>
                    <Row>
                        <Col
                            lg="12"
                            className=""
                            style={{ borderRight: "1px solid #3da0aa4f" }}
                        >
                            {(consenFormStatusLoading || appointmentDetailsLoading || updateAppointmentLoading || updateApptPriceLoading || sendSingleConsentLoading || resendConsentLoading || sendMailTherapistLoading) && (
                                <LoadingOverlay />
                            )}
                            <Row>
                                <Col lg="12" className="my-3">
                                    <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                                        <div className="left">
                                            <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                                                <li className="">
                                                    <Link
                                                        className="themeBlue fw-sbold back-to-btn"
                                                        to={APPOINTMENT_LIST}
                                                    >
                                                        <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                                                        </svg> Back
                                                    </Link>
                                                </li>
                                                <li className="">
                                                    <Link
                                                        className="themeBlue fw-sbold"
                                                        style={{ textDecoration: "underline" }}
                                                        to={APPOINTMENT_LIST}
                                                    >
                                                        Appointments
                                                    </Link>
                                                </li>
                                                <li className="">
                                                    <h5 className="m-0 fw-bold themeBlue">/ Details</h5>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className="right">
                                            <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                                                <li className="">
                                                    {/* <Button
                                                        className="d-flex align-items-center rounded-pill justify-content-center btn-sm"
                                                        variant="outline-success"
                                                        onClick={() => navigate(MANAGE_PARENTS_EDIT.replace(":id", id))}
                                                    >
                                                        <span className="icn me-1">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="18"
                                                                height="18"
                                                                viewBox="0 0 18 18"
                                                                fill="none"
                                                            >
                                                                <mask
                                                                    id="mask0_0_2439"
                                                                    style={{ maskType: "alpha" }}
                                                                    maskUnits="userSpaceOnUse"
                                                                    x="0"
                                                                    y="0"
                                                                    width="18"
                                                                    height="18"
                                                                >
                                                                    <rect width="18" height="18" fill="#D9D9D9" />
                                                                </mask>
                                                                <g mask="url(#mask0_0_2439)">
                                                                    <path
                                                                        d="M1.5 17.9997V15.7497H16.5V17.9997H1.5ZM4.5 12.3099H5.42737L11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L4.5 11.3825V12.3099ZM3.375 13.4349V10.9036L11.7823 2.50792C11.8909 2.3993 12.0142 2.31711 12.1523 2.26136C12.2901 2.20561 12.4336 2.17773 12.5828 2.17773C12.732 2.17773 12.8765 2.20561 13.0163 2.26136C13.156 2.31711 13.2841 2.40317 13.4004 2.51955L14.3019 3.43249C14.4183 3.54111 14.5024 3.66555 14.5543 3.8058C14.6062 3.94592 14.6321 4.0908 14.6321 4.24042C14.6321 4.38067 14.6058 4.52011 14.5532 4.65873C14.5006 4.79748 14.4168 4.9243 14.3019 5.03917L5.90625 13.4349H3.375ZM11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L11.6524 6.0963Z"
                                                                        fill="currentColor"
                                                                    />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                        Edit
                                                    </Button> */}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                                {isLoading ? (
                                    <LoadingIndicator />
                                ) : isError ? (
                                    <ErrorComponent />
                                ) : (
                                    <Col lg="12" className="my-3">
                                        {/* <div className="top d-flex align-items-center gap-10">
                                                <div
                                                    className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                                                    style={{ height: 35, width: 35, background: "#DBDBDB" }}
                                                >
                                                    {lessonDetails?.title?.[0]?.toUpperCase() || ""}
                                                </div>
                                                <div className="content">
                                                    <h6 className="m-0 themeBlue fw-sbold">{lessonDetails?.title || "--"}</h6>
                                                </div>
                                            </div> */}
                                        <Row>
                                            <Col md="12" sm="6" className="my-2">
                                                <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                    <h6 className="m-0 themeBlue fw-bold">
                                                        {" "}
                                                        <span className="" style={{ color: "#3DA0AA" }}>
                                                            ■
                                                        </span>{" "}
                                                        Appointment progress tracker
                                                    </h6>
                                                    <div className="m-0 forteen themeBlue pt-4">
                                                        <AppointmentProgressTracker
                                                            steps={appointment?.record?.steptracker?.steps || []}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="4" sm="12" className="my-2">
                                                <Row className="h-100">
                                                    <Col md="12" sm="12" className="my-2">
                                                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                            <h6 className="m-0 themeBlue fw-bold">
                                                                {" "}
                                                                <span className="" style={{ color: "#3DA0AA" }}>
                                                                    ■
                                                                </span>{" "}
                                                                Title
                                                            </h6>
                                                            <p className="m-0 forteen themeBlue pt-2">{appointment?.record?.title || "--"}</p>
                                                        </div>
                                                    </Col>
                                                    {/* <Col md="12" sm="12" className="my-2">
                                                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                            <h6 className="m-0 themeBlue fw-bold">
                                                                {" "}
                                                                <span className="" style={{ color: "#3DA0AA" }}>
                                                                    ■
                                                                </span>{" "}
                                                                Appointment Reason
                                                            </h6>
                                                            <p className="m-0 forteen themeBlue pt-2">{appointment?.record?.appointment_reason || "--"}</p>
                                                        </div>
                                                    </Col> */}
                                                    {/* <Col md="12" sm="12" className="my-2">
                                                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                            <h6 className="m-0 themeBlue fw-bold">
                                                                {" "}
                                                                <span className="" style={{ color: "#3DA0AA" }}>
                                                                    ■
                                                                </span>{" "}
                                                                Description
                                                            </h6>
                                                            <p className="m-0 forteen themeBlue pt-2">{appointment?.record?.description || "--"}</p>
                                                        </div>
                                                    </Col> */}
                                                </Row>
                                            </Col>
                                            <Col md="8" sm="12" className="my-2">
                                                <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                    <h6 className="m-0 themeBlue fw-bold">
                                                        {" "}
                                                        <span className="" style={{ color: "#3DA0AA" }}>
                                                            ■
                                                        </span>{" "}
                                                        Consent Forms Tracking
                                                    </h6>
                                                    <div>
                                                        <TableLayout
                                                            data={consentFormTracking}
                                                            column={consentFormsTracking}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md="3" sm="6" className="my-2">
                                                <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                    <h6 className="m-0 themeBlue fw-bold">
                                                        {" "}
                                                        <span className="" style={{ color: "#3DA0AA" }}>
                                                            ■
                                                        </span>{" "}
                                                        Parent Last Name
                                                    </h6>
                                                    <p className="m-0 forteen themeBlue pt-2">{`${appointment?.record?.appointmentGuardian?.firstname}`}</p>
                                                </div>
                                            </Col>
                                            <Col md="3" sm="6" className="my-2">
                                                <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                    <h6 className="m-0 themeBlue fw-bold">
                                                        {" "}
                                                        <span className="" style={{ color: "#3DA0AA" }}>
                                                            ■
                                                        </span>{" "}
                                                        Parent First Name
                                                    </h6>
                                                    <p className="m-0 forteen themeBlue pt-2">{`${appointment?.record?.appointmentGuardian?.firstname}`}</p>
                                                </div>
                                            </Col>
                                            <Col md="3" sm="6" className="my-2">
                                                <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                    <h6 className="m-0 themeBlue fw-bold">
                                                        {" "}
                                                        <span className="" style={{ color: "#3DA0AA" }}>
                                                            ■
                                                        </span>{" "}
                                                        Parent Email
                                                    </h6>
                                                    <p className="m-0 forteen themeBlue pt-2">{`${appointment?.record?.appointmentGuardian?.email}`}</p>
                                                </div>
                                            </Col>
                                            <Col md="3" sm="6" className="my-2">
                                                <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                    <h6 className="m-0 themeBlue fw-bold">
                                                        {" "}
                                                        <span className="" style={{ color: "#3DA0AA" }}>
                                                            ■
                                                        </span>{" "}
                                                        Parent Phone
                                                    </h6>
                                                    <p className="m-0 forteen themeBlue pt-2">{`${appointment?.record?.appointmentGuardian?.phone}`}</p>
                                                </div>
                                            </Col>
                                            <Col md="6" sm="6" className="my-2">
                                                <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                    <h6 className="m-0 themeBlue fw-bold">
                                                        {" "}
                                                        <span className="" style={{ color: "#3DA0AA" }}>
                                                            ■
                                                        </span>{" "}
                                                        Client Type
                                                    </h6>
                                                    <p className="m-0 forteen themeBlue pt-2">{`${CLIENT_TYPE_OPTIONS?.find(item => item?.value == appointment?.record?.appointmentClient?.client_detail?.client_type)?.label}`}</p>
                                                </div>
                                            </Col>
                                            <Col md="6" sm="6" className="my-2">
                                                <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                    <h6 className="m-0 themeBlue fw-bold">
                                                        {" "}
                                                        <span className="" style={{ color: "#3DA0AA" }}>
                                                            ■
                                                        </span>{" "}
                                                        Client Name
                                                    </h6>
                                                    <p className="m-0 forteen themeBlue pt-2">{`${appointment?.record?.appointmentClient?.firstname} ${appointment?.record?.appointmentClient?.lastname}`}</p>
                                                </div>
                                            </Col>
                                            <Col md="6" sm="6" className="my-2">
                                                <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                    <h6 className="m-0 themeBlue fw-bold">
                                                        {" "}
                                                        <span className="" style={{ color: "#3DA0AA" }}>
                                                            ■
                                                        </span>{" "}
                                                        Appointment Type
                                                    </h6>
                                                    <p className="m-0 forteen themeBlue pt-2 text-capitalize">{appointment?.record?.appointment_type || "--"}</p>
                                                </div>
                                            </Col>
                                            <Col md="6" sm="6" className="my-2">
                                                <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                    <h6 className="m-0 themeBlue fw-bold">
                                                        <span style={{ color: "#3DA0AA" }}>■</span> Services
                                                    </h6>
                                                    <ul className="d-flex flex-wrap gap-2 ps-3 pt-2 text-capitalize">
                                                        {assessmentOptions?.map((item, index) => (
                                                            <li style={{ background: "#e3e3e3", padding: "2px 6px", borderRadius: "9px", fontSize: "15px" }} key={index} className="me-3 ">{item?.label}</li>
                                                        )) || "--"}
                                                    </ul>
                                                </div>
                                            </Col>
                                            {/* <Col md="3" sm="6" className="my-2">
                                                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                        <h6 className="m-0 themeBlue fw-bold">
                                                            {" "}
                                                            <span className="" style={{ color: "#3DA0AA" }}>
                                                                ■
                                                            </span>{" "}
                                                            Consent Forms
                                                        </h6>
                                                        <p className="m-0 forteen themeBlue pt-2 text-capitalize"><ul>{appointment?.assignedConsentForms?.map((item) => <li>{item?.title}</li>) || "--"}</ul></p>
                                                    </div>
                                                </Col> */}
                                            <Col md="12" sm="6" className="my-2">
                                                <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                    <h6 className="m-0 themeBlue fw-bold">
                                                        {" "}
                                                        <span className="" style={{ color: "#3DA0AA" }}>
                                                            ■
                                                        </span>{" "}
                                                        Additional Notes
                                                    </h6>
                                                    <p className="m-0 forteen themeBlue pt-2 text-capitalize">{appointment?.record?.additional_notes || "--"}</p>
                                                </div>
                                            </Col>
                                            {
                                                ["funded", "free"]?.includes(appointment?.record?.appointment_type) ?
                                                    <Col md="5" sm="6" className="my-2">
                                                        <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                            <h6 className="m-0 themeBlue fw-bold">
                                                                {" "}
                                                                <span className="" style={{ color: "#3DA0AA" }}>
                                                                    ■
                                                                </span>{" "}
                                                                {"Documents"}
                                                            </h6>
                                                            <div className="d-flex gap-2 ">
                                                                {/* <img src={formIcn} alt=""
                                                                className="img-fluid" /> */}
                                                                {
                                                                    appointment?.record?.clientResources ?
                                                                        <>
                                                                            <p className="m-0 forteen themeBlue pt-2 text-capitalize">{appointment?.record?.clientResources}</p>
                                                                            <IconButton
                                                                                onClick={() => {
                                                                                    handleViewPdf(appointment?.record?.clientResources);
                                                                                }}
                                                                            >
                                                                                <span className="icn">
                                                                                    <ViewDocumentIcon />
                                                                                </span>
                                                                            </IconButton>
                                                                        </>
                                                                        : "--"
                                                                }

                                                            </div>
                                                        </div>
                                                    </Col>
                                                    :
                                                    <Col lg="4" className="my-3">
                                                        <div className="w-100">

                                                            <label className="form-label fw-bold themeBlue d-flex my-2">Price ($CAD)</label>
                                                            <input
                                                                disabled={appointment?.record?.payment_status == "success"}
                                                                type="number"
                                                                // ref={timeInputRef}
                                                                // onClick={handleInputClick}
                                                                onWheel={(e) => e.target.blur()} // disables scroll increment
                                                                onChange={(e) => setAppointmentPrice(e.target.value)}
                                                                value={appointmentPrice}
                                                                className={`${styles.formControl} form-control`}
                                                                autoComplete='off'
                                                            />

                                                            {/* {meta.touched && meta.error ? (
                                                        <div className="error">{meta.error}</div>
                                                    ) : null} */}
                                                        </div>
                                                    </Col>
                                            }


                                            {
                                                !["funded", "free"]?.includes(appointment?.record?.appointment_type) &&
                                                <>
                                                    <Col lg={6}>
                                                        <Row>
                                                            <Col lg="3" className="my-2">
                                                                <div className='mt-5'>
                                                                    {/* {errorMessage && <div className='my-2 error'>{errorMessage}</div>} */}
                                                                    {(appointment?.record?.payment_status === "success" || getApptTrackerStepStatus("step3", appointment?.record?.steptracker?.steps)?.status === "completed") ? (
                                                                        <Button
                                                                            type="button"
                                                                            disabled={appointment?.record?.payment_status == "success"}
                                                                            className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                                            // disabled={isSubmitted || saveFormLoading}
                                                                            onClick={() => updatePrice()}
                                                                        >
                                                                            {updateAppointmentLoading ? <LoadingIndicator color='#fff' inline /> : appointment?.record?.payment_status == "success" ? "Paid" : "Update Price"}
                                                                        </Button>
                                                                    ) : (
                                                                        <CommonToolTip
                                                                            text={"Price can be updated once all the consent forms are verified."}
                                                                            component={(
                                                                                <Button
                                                                                    type="button"
                                                                                    onClick={() => { }}
                                                                                    className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                                                >
                                                                                    Update Price
                                                                                </Button>
                                                                            )}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </Col>

                                                            <Col lg="3" className="my-2">
                                                                <div className='mt-5'>
                                                                    {/* {errorMessage && <div className='my-2 error'>{errorMessage}</div>} */}
                                                                    <Button
                                                                        type="button"
                                                                        disabled={createInvoiceLoading}
                                                                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                                        // disabled={isSubmitted || saveFormLoading}
                                                                        onClick={() => handleCreateInvoice()}
                                                                    >
                                                                        {createInvoiceLoading ? <LoadingIndicator color='#fff' inline /> : "Create Invoice"}
                                                                    </Button>
                                                                </div>
                                                            </Col>

                                                            <Col lg="3" className="my-2">
                                                                <div className='mt-5'>
                                                                    {/* {errorMessage && <div className='my-2 error'>{errorMessage}</div>} */}
                                                                    <Button
                                                                        type="button"
                                                                        disabled={sendInvoiceLoading}
                                                                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                                        // disabled={isSubmitted || saveFormLoading}
                                                                        onClick={() => handleSendInvoice()}
                                                                    >
                                                                        {/* {sendInvoiceLoading ? <LoadingIndicator color='#fff' inline /> : appointment?.record?.payment_status == "success" ? "Paid" : "Update Price"} */}
                                                                        {sendInvoiceLoading ? <LoadingIndicator color='#fff' inline /> : "Send Invoice"}
                                                                    </Button>
                                                                </div>
                                                            </Col>

                                                            <Col lg="3" className="my-2">
                                                                <div className='mt-5'>
                                                                    {/* {errorMessage && <div className='my-2 error'>{errorMessage}</div>} */}
                                                                    <Button
                                                                        type="button"
                                                                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                                        disabled={appointment?.record?.payment_status != "success" || sendRecieptLoading}
                                                                        onClick={() => handleSendReciept()}
                                                                    >
                                                                        {sendRecieptLoading ? <LoadingIndicator color='#fff' inline /> : "Send Reciept"}
                                                                    </Button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </>
                                            }



                                            {/* <Col md="5" sm="6" className="my-2">
                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                              <h6 className="m-0 themeBlue fw-bold">
                                {" "}
                                <span className="" style={{ color: "#3DA0AA" }}>
                                  ■
                                </span>{" "}
                                Files
                              </h6>
                              <ul>
                                {
                                  lessonDetails?.files?.map((item, index) => {
                                    return (<li><p key={index} className="m-0 forteen themeBlue pt-2">{item?.attachment_name || "--"}</p></li>)
                                  })
                                }
                              </ul>

                            </div>
                          </Col> */}
                                            <Col lg="12" className="my-3 mt-5">
                                                <div className="top d-flex justify-content-between align-items-end">
                                                    <h6 className="m-0 themeBlue fw-sbold">Assigned Consent Forms: </h6>
                                                    <CommonToolTip
                                                        text={"Resend consent forms to parent via email."}
                                                        component={
                                                            <Button
                                                                type="button"
                                                                className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold gap-2"
                                                                onClick={handleResendConsentForms}
                                                                disabled={resendConsentLoading}
                                                            >
                                                                {resendConsentLoading ? <LoadingIndicator inline={true} /> : ""} Resend Consent Forms
                                                            </Button>
                                                        }
                                                    />
                                                </div>
                                                {/* <p className="m-0 forteen themeBlue">
                                                        {lessonDetails?.description || "--"}
                                                    </p> */}
                                                <div className="table-outer">
                                                    {isLoading ? (
                                                        <div style={{ height: "200px" }}>
                                                            <LoadingIndicator />
                                                        </div>
                                                    ) : isError ? (
                                                        <ErrorComponent />
                                                    ) : (
                                                        <>
                                                            {(isLoading) && (
                                                                <LoadingOverlay />
                                                            )}
                                                            <TableLayout data={appointment?.assignedConsentForms} column={column} />
                                                        </>
                                                    )}
                                                </div>
                                            </Col>

                                            {
                                                appointment?.record?.appointmentClient?.client_detail?.client_type != "chatter" ?
                                                    <>
                                                        <Col lg="12" className="">
                                                            <div className="top d-flex justify-content-between align-items-end">
                                                                <h6 className="m-0 fw-bold pb-2">Assigned Therapists</h6>
                                                                {console.log("appointment", appointment)}
                                                                {
                                                                    (appointment?.record?.appointment_type === "paid" && getApptTrackerStepStatus("step5", appointment?.record?.steptracker?.steps)?.status === "completed") ||
                                                                        ((appointment?.record?.appointment_type === "funded" && getApptTrackerStepStatus("step3", appointment?.record?.steptracker?.steps)?.status === "completed")) ? (
                                                                        <Button
                                                                            type="button"
                                                                            className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                                            disabled={unAssignAllTherapistsLoading}
                                                                            onClick={() => {
                                                                                // setModalType("unassignAll")
                                                                                setAssignModal(true)
                                                                            }}
                                                                        >
                                                                            {"Assign therapist"}
                                                                        </Button>
                                                                    ) : (
                                                                        <Button
                                                                            type="button"
                                                                            className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                                            disabled={true}
                                                                        >
                                                                            Assign therapist
                                                                        </Button>
                                                                    )
                                                                }
                                                            </div>
                                                        </Col>

                                                        <Col lg="12" className="my-3">
                                                            {/* <h6 className="m-0 themeBlue fw-sbold">Consent Forms: </h6> */}
                                                            {/* <p className="m-0 forteen themeBlue">
        {lessonDetails?.description || "--"}
    </p> */}
                                                            <div className="table-outer">
                                                                {assignedTherapistListLoading ? (
                                                                    <div style={{ height: "200px" }}>
                                                                        <LoadingIndicator />
                                                                    </div>
                                                                ) : isError ? (
                                                                    <ErrorComponent />
                                                                ) : (
                                                                    <>
                                                                        {(assignedTherapistListLoading) && (
                                                                            <LoadingOverlay />
                                                                        )}
                                                                        <TableLayout data={assignedTherapistList} column={therapistColumn} />
                                                                    </>
                                                                )}
                                                            </div>
                                                        </Col>
                                                        {/* <Col lg="12" className="my-1">
                                                                <div className="top pb-3 d-flex justify-content-between align-items-center">
                                                                    <h6 className="m-0 fw-bold pb-2">Assign New Therapists</h6>
                                                                </div>
                                                            </Col> */}

                                                        {/* <Col lg="12" className="">
                                                                <Formik
                                                                    initialValues={{
                                                                        therapists: [{ lastname: "", firstname: "", email: "", service: "", id: "" }]
                                                                    }}
                                                                    validationSchema={validationTherapistSchema}
                                                                    onSubmit={handleTherpaistSubmit}
                                                                    enableReinitialize
                                                                >
                                                                    {({
                                                                        handleSubmit, values, setFieldValue
                                                                    }) => (
                                                                        <Form onSubmit={handleSubmit}>
                                                                            <div
                                                                                className=""
                                                                            //   style={{ borderTop: "1px solid #41a2a84d" }}
                                                                            >
                                                                                <Row>
                                                                                    <Col lg="12">
                                                                                        <FieldArray name="therapists">
                                                                                            {({ insert, remove, push }) => (
                                                                                                <ul className="list-unstyled ps-0 mb-0">
                                                                                                    {values.therapists.length > 0 &&
                                                                                                        values.therapists.map((area, index) => {
                                                                                                            let isLastItem = index === values.therapists.length - 1;
                                                                                                            return (
                                                                                                                <Row className="align-items-center" key={index}>
                                                                                                                    <Col lg="10">
                                                                                                                        <Row>
                                                                                                                            <Col md="3" sm="6" className="my-2">
                                                                                                                                <label
                                                                                                                                    htmlFor=""
                                                                                                                                    className="form-label themeBlue fw-bold mb-0 d-flex"
                                                                                                                                >
                                                                                                                                    Last Name
                                                                                                                                    <RequiredFieldAstrick />
                                                                                                                                </label>
                                                                                                                                <CommonSelect
                                                                                                                                    placeholder={"Select Therapist"}
                                                                                                                                    isClearable
                                                                                                                                    name={`values?.therapists?.[${index}]?.lastname`}
                                                                                                                                    handleBlur={() => setTherapistOptions([])}
                                                                                                                                    // creatable={true}
                                                                                                                                    onInputChange={(e) => handleSearch(e, "parents}")}
                                                                                                                                    option={therapistOptions}
                                                                                                                                    isLoading={therapistsLoading}
                                                                                                                                    value={values?.therapists?.[index]?.lastname && { label: values?.therapists?.[index]?.lastname, value: values?.therapists?.[index]?.lastname }}
                                                                                                                                    onChange={(selected) => {
                                                                                                                                        let therapist = therapistOptions?.find(therapist => therapist.id === selected?.value);
                                                                                                                                        let selectedValue = {
                                                                                                                                            ...selected,
                                                                                                                                            label: therapist?.lastname
                                                                                                                                        };
                                                                                                                                        if (!therapist) {
                                                                                                                                            // setClientOptions([])
                                                                                                                                            setFieldValue(`therapists.${index}.lastname`, selected);
                                                                                                                                            setFieldValue(`therapists.${index}.id`, null);
                                                                                                                                            setFieldValue(`therapists.${index}.firstname`, "");
                                                                                                                                            setFieldValue(`therapists.${index}.email`, "");
                                                                                                                                            setFieldValue(`therapists.${index}.phone`, "");
                                                                                                                                            // setFieldValue('clientType', "")
                                                                                                                                            // setFieldValue('clientId', "")
                                                                                                                                            // setConsentFormOptions([]);
                                                                                                                                            // setFieldValue("consentForms", []);

                                                                                                                                            return;
                                                                                                                                        }
                                                                                                                                        setFieldValue(`therapists.${index}.lastname`, therapist.lastname);
                                                                                                                                        setFieldValue(`therapists.${index}.id`, selectedValue.id);
                                                                                                                                        setFieldValue(`therapists.${index}.firstname`, therapist?.firstname);
                                                                                                                                        setFieldValue(`therapists.${index}.email`, therapist?.email);
                                                                                                                                        setFieldValue(`therapists.${index}.phone`, therapist?.phone);
                                                                                                                                        // setFieldValue('clientType', "")
                                                                                                                                        // setFieldValue('clientId', "")
                                                                                                                                        setTherapistOptions([])
                                                                                                                                        // setConsentFormOptions([]);
                                                                                                                                        // setFieldValue("consentForms", []);
                                                                                                                                    }}
                                                                                                                                />
                                                                                                                            </Col>
                                                                                                                            <Col md="3" sm="6" className="my-2">
                                                                                                                                <label
                                                                                                                                    htmlFor=""
                                                                                                                                    className="form-label themeBlue fw-bold mb-0 d-flex"
                                                                                                                                >
                                                                                                                                    First Name
                                                                                                                                    <RequiredFieldAstrick />
                                                                                                                                </label>
                                                                                                                                <AppInputField
                                                                                                                                    disabled={!!area?.id}
                                                                                                                                    name={`therapists.${index}.firstname`}
                                                                                                                                    placeholder="e.g John Smith"
                                                                                                                                    className={`${styles.formControl} form-control`}
                                                                                                                                />
                                                                                                                            </Col>

                                                                                                                            <Col md="3" sm="6" className="my-2">
                                                                                                                                <label
                                                                                                                                    htmlFor=""
                                                                                                                                    className="form-label themeBlue fw-bold mb-0 d-flex"
                                                                                                                                >
                                                                                                                                    Email
                                                                                                                                    <RequiredFieldAstrick />
                                                                                                                                </label>
                                                                                                                                <AppInputField
                                                                                                                                    disabled={!!area?.id}
                                                                                                                                    name={`therapists.${index}.email`}
                                                                                                                                    placeholder="John@gmail.com"
                                                                                                                                    className={`${styles.formControl} form-control`}
                                                                                                                                />
                                                                                                                            </Col>
                                                                                                                            <Col md="3" sm="4">
                                                                                                                                <label className="form-label fw-bold themeBlue d-flex">
                                                                                                                                    Service
                                                                                                                                    <RequiredFieldAstrick />
                                                                                                                                </label>
                                                                                                                                <CommonMultiSelect
                                                                                                                                    name={`therapists.${index}.service`}
                                                                                                                                    option={assessmentOptions}
                                                                                                                                    placeholder={"Select Service"}
                                                                                                                                // onChange={(val) => {
                                                                                                                                //   setClientOptions([]);
                                                                                                                                //   getClientOptions(val);
                                                                                                                                //   setValues({
                                                                                                                                //     ...values,
                                                                                                                                //     client_type: val,
                                                                                                                                //     client_id: ""
                                                                                                                                //   })
                                                                                                                                // }}
                                                                                                                                />
                                                                                                                            </Col>
                                                                                                                        </Row>
                                                                                                                    </Col>
                                                                                                                    <Col lg="2">
                                                                                                                        <Button
                                                                                                                            className="border-0 p-0"
                                                                                                                            variant="transparnet"
                                                                                                                        >
                                                                                                                            {isLastItem ? (

                                                                                                                                values.therapists.length > 1 ? (
                                                                                                                                    <>
                                                                                                                                        <PlusIcon onClick={() => push({ ...singleParent })} />
                                                                                                                                        <MinusIcon onClick={() => {
                                                                                                                                            // if (area.id && parents.includes(area.id)) {
                                                                                                                                            //     setCurrentEntry({ ...area, setFieldValue, list: values?.parents });
                                                                                                                                            //     setShowModal(true);
                                                                                                                                            //     return;
                                                                                                                                            // }
                                                                                                                                            remove(index)
                                                                                                                                        }} />
                                                                                                                                    </>
                                                                                                                                ) : <PlusIcon onClick={() => push({ ...singleParent })} />

                                                                                                                            ) : <MinusIcon onClick={() => {
                                                                                                                                // if (area.id && parents.includes(area.id)) {
                                                                                                                                //     setCurrentEntry({ ...area, setFieldValue, list: values?.parents });
                                                                                                                                //     setShowModal(true);
                                                                                                                                //     return;
                                                                                                                                // }
                                                                                                                                remove(index)
                                                                                                                            }} />
                                                                                                                            }
                                                                                                                        </Button>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                            )
                                                                                                        })}
                                                                                                </ul>
                                                                                            )}
                                                                                        </FieldArray>
                                                                                    </Col>
                                                                                    <Col lg="2" className="my-2">
                                                                                        <div className='mt-5'>
                                                                                            <Button
                                                                                                type="submit"
                                                                                                className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                                                                disabled={appointment?.record?.payment_status != "success" && appointment?.record?.appointment_type == "paid"}
                                                                                            // disabled={isSubmitted || saveFormLoading}
                                                                                            // onClick={() => updatePrice()}
                                                                                            >
                                                                                                {assignTherapistLoading ? <LoadingIndicator color='#fff' inline /> : "Assign"}
                                                                                            </Button>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>
                                                                            </div>
                                                                        </Form>)}
                                                                </Formik>
                                                            </Col> */}
                                                    </>
                                                    :
                                                    <>
                                                        <Col lg="12" className="">
                                                            <div className="top d-flex justify-content-between align-items-end">
                                                                <h6 className="m-0 fw-bold pb-2">Assigned Chatter Programs</h6>
                                                                <Button
                                                                    type="button"
                                                                    className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                                    disabled={unAssignAllTherapistsLoading}
                                                                    onClick={() => {
                                                                        // setModalType("unassignAll")
                                                                        setAssignModal(true)
                                                                    }}
                                                                >
                                                                    {"Assign Chatter"}
                                                                </Button>
                                                            </div>
                                                        </Col>

                                                        <Col lg="12" className="my-3">
                                                            {/* <h6 className="m-0 themeBlue fw-sbold">Consent Forms: </h6> */}
                                                            {/* <p className="m-0 forteen themeBlue">
                                                                    {lessonDetails?.description || "--"}
                                                                </p> */}
                                                            <div className="table-outer">
                                                                {assignChatterListLoading ? (
                                                                    <div style={{ height: "200px" }}>
                                                                        <LoadingIndicator />
                                                                    </div>
                                                                ) : isError ? (
                                                                    <ErrorComponent />
                                                                ) : (
                                                                    <>
                                                                        {(assignChatterListLoading) && (
                                                                            <LoadingOverlay />
                                                                        )}
                                                                        <TableLayout data={assignedChatterList?.chatterAssignedList} column={assignedChattersColumn} />
                                                                    </>
                                                                )}
                                                            </div>
                                                        </Col>

                                                        {/* <Col lg="12">
                                                                <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                                                                    <div className="left">
                                                                        <TableHeader
                                                                            heading={"Chatter Program Profiles"}
                                                                            handleFilterChange={handleFilterChange}
                                                                            resetFilter={resetFilter}
                                                                            filter={filter}
                                                                            searchPlaceholder="Program Name"
                                                                        />
                                                                    </div>
                                                                    <div className="table-outer">
                                                                        {isLoading ? (
                                                                            <div style={{ height: "200px" }}>
                                                                                <LoadingIndicator />
                                                                            </div>
                                                                        ) : isError ? (
                                                                            <ErrorComponent />
                                                                        ) : (
                                                                            <>
                                                                                {(isFetching) && <LoadingOverlay />}
                                                                                <TableLayout
                                                                                    data={chatterData?.lessons}
                                                                                    column={chattetColumn}
                                                                                    url={"/manage-chatter/program-profiles/detail"}
                                                                                    filter={filter}
                                                                                    handleSort={handleFilterChange("sort")}
                                                                                />
                                                                            </>
                                                                        )}
                                                                        <CstmPagination
                                                                            totalPages={totalPages}
                                                                            activePage={currentPage}
                                                                            handlePageChange={handlePageChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </Col> */}
                                                    </>
                                            }
                                        </Row>
                                    </Col>
                                )}
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

const singleParent = {
    firstname: "",
    lastname: "",
    phone: "",
    email: ""
}

export default AppointmentDetail;
